import EE from '~/listenerEventService/EventEmitter';
import { clickstreamLogger } from '~/logging';
import settings from '~/utils/Settings';

export default class TimeListener extends EE implements IListener {
  timer: number = null;
  startTime = new Date().getTime();

  get interval() {
    return settings.getOrDefault('TIME_EVENT_INTERVAL', 1000);
  }

  start() {
    this.timer = window.setInterval(this.intervalHandler, this.interval);
  }

  stop() {
    clearTimeout(this.timer);
  }

  intervalHandler = () => {
    const currentTime = new Date().getTime();
    /* clickstreamLogger.debug(
      `Time event happened, time: ${
        (currentTime - this.startTime) / 1000
      } seconds`
    ); */

    this.emit('analytics', {
      type: 'time',
      target: document,
      time: currentTime,
      save: false,
    });
  }
}
